import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NodeService } from 'src/app/services/ngx-drupal7-services';
import { HelpersService, PALLET_OVERRIDES } from 'src/app/services/helpers.service';
import { VocabularyService } from 'src/app/services/vocabulary.service';
import { TermSelectPage } from '../term-select/term-select.page';

@Component({
  selector: 'app-pallet-overrides',
  templateUrl: './pallet-overrides.page.html',
  styleUrls: ['./pallet-overrides.page.scss'],
})
export class PalletOverridesPage implements OnInit {
  @Input() node: any;

  loading = true;
  saving = false;
  calipers = [];
  customers = [];
  sizes = [];
  customerName = '';
  sizeName = '';
  values: PALLET_OVERRIDES = null;

  constructor(
    private modalCtrl: ModalController,
    private nodeService: NodeService,
    private vocabularyService: VocabularyService,
    public helpers: HelpersService
  ) { }

  ngOnInit() {
    this.values = {
      customer2: this.helpers.getTaxonomyValue(this.node, 'customer2'),
      itempo: this.helpers.getValue(this.node, 'itempo'),
      caliper2: this.helpers.getTaxonomyValue(this.node, 'caliper2'),
      size_caliper: this.helpers.getTaxonomyValue(this.node, 'size_caliper'),
      additional_information: this.helpers.getValue(this.node, 'additional_information'),
      part_no_: this.helpers.getValue(this.node, 'part_no_')
    };
    Promise.all([
      this.vocabularyService.getCalipers(),
      this.vocabularyService.getCustomers(),
      this.vocabularyService.getSizes()
    ]).then((results) => {
      this.calipers = results[0] || [];
      this.customers = results[1] || [];
      this.sizes = results[2] || [];
      this.customerName = this.nameFor(this.customers, this.values.customer2);
      this.sizeName = this.nameFor(this.sizes, this.values.size_caliper);
      this.loading = false;
    }, (err) => {
      this.loading = false;
      this.helpers.presentToast(err);
    });
  }

  nameFor(items, tid): string {
    if (!tid) {
      return '';
    }
    const match = (items || []).filter(item => item.tid == tid)[0];
    return match ? match.name : '';
  }

  async pick(items, title, selectedTid) {
    const modal = await this.modalCtrl.create({
      component: TermSelectPage,
      componentProps: { items, title, selectedTid }
    });
    await modal.present();
    const result = await modal.onDidDismiss();
    return result && result.data ? result.data : null;
  }

  async pickCustomer() {
    const picked = await this.pick(this.customers, 'Ship To Customer', this.values.customer2);
    if (picked) {
      this.values.customer2 = picked.tid;
      this.customerName = picked.name;
    }
  }

  async pickSize() {
    const picked = await this.pick(this.sizes, 'Size', this.values.size_caliper);
    if (picked) {
      this.values.size_caliper = picked.tid;
      this.sizeName = picked.name;
    }
  }

  submit(form) {
    this.saving = true;
    // Only these six fields go in the payload. The Drupal services node resource
    // replays the node form rather than merging, so a field left out keeps its
    // current value while an empty one is cleared. Converting Type is edited on
    // the Drupal form only, so it must stay out of this payload entirely.
    const node: any = {
      nid: this.node.nid,
      type: this.node.type,
      field_customer2: this.helpers.prepTaxonomyValue(this.values.customer2),
      field_caliper2: this.helpers.prepTaxonomyValue(this.values.caliper2),
      field_size_caliper: this.helpers.prepTaxonomyValue(this.values.size_caliper),
      field_itempo: this.helpers.prepValue(this.values.itempo),
      field_part_no_: this.helpers.prepValue(this.values.part_no_),
      field_additional_information: this.helpers.prepValue(this.values.additional_information)
    };
    this.nodeService.updateNode(node).subscribe(() => {
      this.helpers.presentToast(this.node.title + ' has been updated');
      this.modalCtrl.dismiss({ saved: true });
    }, (err) => {
      this.saving = false;
      this.helpers.presentToast(err);
    });
  }

  cancel() {
    this.modalCtrl.dismiss();
  }

}
